
export default function CommercialServices() {
  const services = [
    {
      icon: 'ri-building-2-line',
      title: 'Office Renovations',
      description:
        'Modern open-plan conversions, executive suites, boardrooms, and collaborative workspaces designed to boost productivity and impress clients.'
    },
    {
      icon: 'ri-store-2-line',
      title: 'Retail Fit-Outs',
      description:
        'Bespoke retail environments from boutique shops to flagship stores. Custom displays, lighting design, and premium finishes that drive foot traffic.'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Restaurant & Hospitality',
      description:
        'Complete restaurant builds, bar fit-outs, hotel lobbies, and hospitality venues with commercial-grade kitchens and compliance‑ready installations.'
    },
    {
      icon: 'ri-hospital-line',
      title: 'Medical & Wellness',
      description:
        'Specialised medical practice fit‑outs, dental surgeries, wellness centres, and spa environments built to healthcare compliance standards.'
    },
    {
      icon: 'ri-building-4-line',
      title: 'Tenant Improvements',
      description:
        'Rapid tenant improvement projects for landlords and property managers. We deliver quality fit‑outs on tight timelines to minimise vacancy periods.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Compliance & Upgrades',
      description:
        'Fire safety upgrades, accessibility modifications, electrical compliance, and building code upgrades for existing commercial properties.'
    }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-20">
          <p className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase mb-4">
            Our Expertise
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-tight mb-4">
            Commercial Construction{' '}
            <span className="font-serif text-[#D4AF37]">Services</span>
          </h2>
          <p className="text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            From concept to handover, we deliver turnkey commercial projects with
            licensed contractors, transparent pricing, and minimal disruption to
            your business operations.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <article
              key={index}
              className="group bg-[#FDFBF7] rounded-2xl p-6 md:p-8 hover:shadow-xl transition-all duration-400 border border-transparent hover:border-[#D4AF37]/20"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-[#D4AF37]/10 rounded-2xl mb-4 md:mb-6 group-hover:bg-[#D4AF37]/20 transition-colors">
                <i
                  className={`${service.icon} text-xl md:text-2xl text-[#D4AF37]`}
                ></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#2A2A2A] mb-2 md:mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
